module.exports = __webpack_public_path__ + "static/media/target_lv_37fbd0fe776c5f2f50c346e9fd4b8a0cb.webp";